import { z } from 'zod';
import { TenantTypeEnum } from '../types/tenant-type.js';
import { AddPreflightMarketSchema } from '../preflight/market.js';

// ─── Tenant Event Payloads ──────────────────────────────────────────
// Zod schemas for every tenant-domain event.
// These represent the *command* shape published by the API (BFF).

export const TenantProvisionedPayload = z.object({
    tenantId: z.string().cuid2(),
    name: z.string().min(1).max(255),
    type: TenantTypeEnum,
    provisionedBy: z.string(),
    copyAccessFromTenantId: z.string().min(1),
    retoolUserId: z.string().uuid().nullable().optional(),
    description: z.string().max(500).nullable().optional(),
    brandColor: z.string().regex(/^#[0-9a-fA-F]{6}$/).nullable().optional(),
    logoUrl: z.string().url().max(500).nullable().optional(),
    industryIndices: z.array(z.string()).optional(),
    /** Pre Flight catalogue entries to seed on top of Global, named by kind and code. */
    preflightMarketRefs: z.array(AddPreflightMarketSchema).optional(),
});
export type TenantProvisionedPayload = z.infer<typeof TenantProvisionedPayload>;

export const TenantUpdatedPayload = z.object({
    tenantId: z.string(),
    changes: z.record(z.string(), z.unknown()),
    previousName: z.string().optional(),
});
export type TenantUpdatedPayload = z.infer<typeof TenantUpdatedPayload>;

export const TenantDeactivatedPayload = z.object({
    tenantId: z.string(),
    deactivatedBy: z.string(),
});
export type TenantDeactivatedPayload = z.infer<typeof TenantDeactivatedPayload>;

export const TenantReactivatedPayload = z.object({
    tenantId: z.string(),
    reactivatedBy: z.string(),
});
export type TenantReactivatedPayload = z.infer<typeof TenantReactivatedPayload>;

export const ImportTenantSettingsPayload = z.object({
    tenantId: z.string().min(1),
    ownership: z.enum(['ADGE', 'PUBLICIS']),
    industries: z.array(z.string().min(1)).min(1),
    defaultIndustry: z.string().min(1).max(255),
    defaultBrand: z.string().min(1).max(255),
    /** Catalogue entries the tenant does not hold yet; the ones it holds are left alone. */
    preflightMarketRefs: z.array(AddPreflightMarketSchema).optional(),
});
export type ImportTenantSettingsPayload = z.infer<typeof ImportTenantSettingsPayload>;
